import Vue from 'vue';
import Vuex from 'vuex'
import { Zoeken } from './Components';

Vue.config.productionTip = false;

const app = new Vue({
    el: '#zoeken',
    render: (h) => h(Zoeken),
});

export {
    app
}
